module.exports = __webpack_public_path__ + "img/message.82fa1aa5.svg";